import React, { useEffect } from 'react';
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import InHouseProducts from "./components/InHouseProducts";
import About from "./components/About";
import Services from "./components/Services";
import Technologies from "./components/Technologies";
import Solutions from "./components/Solutions";
import Process from "./components/Process";
import AllProjects from "./components/AllProjects";
import Music from './components/Music';
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollProgress from "./components/common/ScrollProgress";
import BackToTop from "./components/common/BackToTop";
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from 'react-hot-toast';
import AOS from 'aos';
import 'aos/dist/aos.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
    });
  }, []);

  // Direct link: https://platypusbox.com/projects opens straight on the full project gallery.
  const isProjectsPage = window.location.pathname.replace(/\/+$/, '') === '/projects';
  useEffect(() => {
    if (isProjectsPage) document.title = 'All Projects | PlatypusBox';
  }, [isProjectsPage]);

  if (isProjectsPage) {
    return (
      <ThemeProvider>
        <div className="min-h-screen bg-[#061a10] text-cream">
          <div className="fixed top-0 left-0 right-0 z-50 bg-forest/90 backdrop-blur-md shadow-lg shadow-black/20">
            <div className="container mx-auto px-4 h-20 flex items-center justify-between">
              <a href="/"><img src="/logo2.png" alt="PlatypusBox Logo" className="h-12 w-auto" /></a>
              <div className="flex items-center gap-3">
                <a
                  href="https://solutions.platypusbox.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hidden sm:inline-block text-cream border border-accent-green/60 hover:bg-accent-green/10 px-4 py-2 rounded-md text-sm transition-colors"
                >
                  Tech Solutions
                </a>
                <a href="/" className="text-forest bg-accent-green hover:bg-accent-green/90 px-4 py-2 rounded-md text-sm font-medium transition-colors">
                  &larr; Home
                </a>
              </div>
            </div>
          </div>
          <AllProjects standalone />
          <Footer />
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background-light dark:bg-background-dark text-text-light-primary dark:text-text-dark-primary transition-colors duration-300">
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              background: 'var(--color-background)',
              color: 'var(--color-text)',
            },
          }}
        />
        <ScrollProgress />
        <Navbar />
        <Header />
        <InHouseProducts />
        <About />
        <Services />
        <Technologies />
        <Solutions />
        <Process />
        <AllProjects />
        {/*<Music />*/}
        <Testimonials />
        <Contact />
        <Footer />
        <BackToTop />
      </div>
    </ThemeProvider>
  );
}

export default App;
